"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _permission = require("@/utils/permission");
var _public = require("@/libs/public");
var _product = require("@/api/product");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'ProductUnit',
  data: function data() {
    return {
      listLoading: true,
      tableData: {
        data: []
      },
      loading: false,
      keyNum: 0,
      tableColumns: [{
        prop: 'id',
        label: 'ID',
        minWidth: 150
      }, {
        label: '单位名称',
        minWidth: 150,
        prop: 'name'
      }, {
        label: '创建时间',
        minWidth: 200,
        prop: 'createTime' // 使用插槽自定义显示（包含注销状态）
      }, {
        // 操作列
        label: '操作',
        width: 100,
        fixed: 'right',
        slotName: 'operate' // 使用插槽自定义操作按钮
      }]
    };
  },
  watch: {},
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:product:unit:list'])) this.getList('');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleEdit: function handleEdit(isCreate, editDate) {
      var _this = this;
      this.id = editDate ? editDate.id : 0;
      this.$modalParserFrom(isCreate === 0 ? '新建单位' : '编辑单位', 'productUnit', isCreate, isCreate === 0 ? {
        id: 0,
        name: '',
        sort: ''
      } : Object.assign({}, editDate), function (formValue) {
        _this.submit(formValue);
      }, this.keyNum += 4);
    },
    //表单提交
    submit: function submit(formValue) {
      var _this2 = this;
      var data = {
        id: this.id,
        name: formValue.name,
        sort: formValue.sort
      };
      !this.id ? (0, _product.productUnitsaveApi)(data).then(function (res) {
        _this2.$message.success('操作成功');
        _this2.$msgbox.close();
        _this2.getList();
      }).catch(function () {
        _this2.loading = false;
      }) : (0, _product.productUnitUpdateApi)(data).then(function (res) {
        _this2.$message.success('操作成功');
        _this2.$msgbox.close();
        _this2.getList();
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 列表
    getList: function getList(num) {
      var _this3 = this;
      this.listLoading = true;
      (0, _product.productUnitListApi)(this.tableForm).then(function (res) {
        _this3.tableData.data = res;
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this4 = this;
      this.$modalSure('删除商品单位吗？').then(function () {
        (0, _product.productUnitDeleteApi)({
          id: id
        }).then(function () {
          _this4.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this4.tableData.data.length, _this4.tableForm);
          _this4.getList('');
        });
      });
    }
  }
};